import config from "../config/config";

// Strip trailing slash so URLs don't get double slashes
const API = (config.API_URL || "").replace(/\/$/, "");

const MIRROR_BASE = "/api/mirror";
const KITE2_BASE  = "/api/kite2";
const UPSTOX_BASE = "/api/upstox";

export const MIRROR_URLS = {
  TODAY:   `${MIRROR_BASE}/today`,
  HISTORY: `${MIRROR_BASE}/history`,
  STATUS:  `${MIRROR_BASE}/status`,
  CONFIG:  `${MIRROR_BASE}/config`,
};

export const KITE2_URLS = {
  LOGIN:      `${API}${KITE2_BASE}/login`,   // absolute — browser <a href> redirect
  STATUS:     `${KITE2_BASE}/status`,
  DISCONNECT: `${KITE2_BASE}/disconnect`,
};

export const UPSTOX_URLS = {
  LOGIN:      `${API}${UPSTOX_BASE}/login`,  // absolute — browser <a href> redirect
  STATUS:     `${UPSTOX_BASE}/status`,
  DISCONNECT: `${UPSTOX_BASE}/disconnect`,
};

// Manual order actions on a destination account (Kite2 / Upstox)
export const MIRROR_ORDER_URLS = {
  create:        (broker: string) => `${MIRROR_BASE}/${broker}/orders`,
  modify:        (broker: string, orderId: string) => `${MIRROR_BASE}/${broker}/orders/${orderId}`,
  cancelOrder:   (broker: string, orderId: string) => `${MIRROR_BASE}/${broker}/orders/${orderId}/cancel`,
  cancelAll:     (broker: string) => `${MIRROR_BASE}/${broker}/orders/cancel-all`,
  closePosition: (broker: string) => `${MIRROR_BASE}/${broker}/positions/close`,
};

// Order guards — conditional LIMIT → MARKET price triggers
export const GUARD_URLS = {
  list:   (broker: string) => `${MIRROR_BASE}/${broker}/guards`,
  create: (broker: string) => `${MIRROR_BASE}/${broker}/guards`,
  cancel: (broker: string, guardId: number) => `${MIRROR_BASE}/${broker}/guards/${guardId}`,
};

// P&L snapshots — manual save + history
export const PNL_SNAPSHOT_URLS = {
  save:    `${MIRROR_BASE}/pnl-snapshot`,
  history: `${MIRROR_BASE}/pnl-snapshot/history`,
};
